import React from "react";
import {
  Wrench,
  Leaf,
  ShieldCheck,
  CalendarClock,
  Eye,
  BadgeCheck,
} from "lucide-react";

const REASONS = [
  { icon: Wrench, title: "Professional-Grade Equipment", desc: "Industrial tools that deliver results consumer products simply can't." },
  { icon: Leaf, title: "Eco-Friendly & Effective", desc: "Powerful results without harsh residues or harmful chemical exposure." },
  { icon: ShieldCheck, title: "Fully Insured", desc: "Complete liability coverage — your facility is protected, always." },
  { icon: CalendarClock, title: "Flexible Scheduling", desc: "Off-hours, weekends, or whenever fits your operation best." },
  { icon: Eye, title: "Detail-Oriented", desc: "We notice the corners, edges, and surfaces others miss." },
  { icon: BadgeCheck, title: "Satisfaction Guaranteed", desc: "If it's not perfect, we make it right. No questions asked." },
];

const WhyUs = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative bg-white py-20 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="mb-16 grid grid-cols-1 items-end gap-8 md:grid-cols-12 md:gap-12">
          <div className="md:col-span-7">
            <p className="mb-6 font-body text-xs font-semibold uppercase tracking-[0.22em] text-blue-600">
              — Why Choose Us
            </p>
            <h2
              data-testid="why-heading"
              className="font-heading text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl"
            >
              Six reasons businesses
              <br />
              <span className="text-blue-600">trust Deep Clean.</span>
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="font-body text-base font-medium leading-relaxed text-slate-600 md:text-lg">
              We earn the trust of every facility we service through equipment,
              products, and people you can count on.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-px overflow-hidden rounded-md bg-slate-200 sm:grid-cols-2 lg:grid-cols-3">
          {REASONS.map((r, i) => (
            <div
              key={r.title}
              data-testid={`why-card-${i}`}
              className="group relative bg-white p-8 transition-colors hover:bg-slate-950 lg:p-10"
            >
              <span className="grid h-12 w-12 place-items-center rounded-md bg-blue-600/10 text-blue-600 transition-colors group-hover:bg-cyan-300/15 group-hover:text-cyan-300">
                <r.icon size={22} strokeWidth={1.6} />
              </span>
              <h3 className="mt-6 font-heading text-lg font-bold tracking-tight text-slate-900 transition-colors group-hover:text-white lg:text-xl">
                {r.title}
              </h3>
              <p className="mt-3 font-body text-sm font-medium leading-relaxed text-slate-600 transition-colors group-hover:text-white/80">
                {r.desc}
              </p>
              <span className="mt-6 block font-body text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-400 transition-colors group-hover:text-cyan-300">
                0{i + 1} / Reason
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
